import { PopoverOrigin } from '@material-ui/core';
import { Position } from './Popover';

export const getOffsetTop = (rect: DOMRect, vertical: string | number | undefined): number => {
  let offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect?.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect?.height;
  }

  return offset;
};

export const getOffsetLeft = (rect: DOMRect, horizontal: string | number | undefined): number => {
  let offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect?.width / 2;
  } else if (horizontal === 'right') {
    offset = rect?.width;
  }

  return offset;
};

const getTransformOriginValue = (transformOrigin: PopoverOrigin): string => {
  return Object.values(transformOrigin)
    .map((n) => `${n}px`)
    .join(' ');
};

export const getPositioningStyle = (
  el: HTMLElement | null,
  anchorEl: HTMLElement | null,
  anchorOrigin: PopoverOrigin,
  transformOrigin: PopoverOrigin,
): Position | undefined => {
  const marginThreshold = 16;
  const getBoundingClientRect = anchorEl?.getBoundingClientRect();

  let top =
    (getBoundingClientRect &&
      getBoundingClientRect.top + getOffsetTop(getBoundingClientRect, anchorOrigin?.vertical)) ||
    0;
  let left =
    (getBoundingClientRect &&
      getBoundingClientRect.left + getOffsetLeft(getBoundingClientRect, anchorOrigin?.horizontal)) ||
    0;

  if (el) {
    const element = el.getBoundingClientRect();

    const elemTransformOrigin = {
      horizontal: getOffsetLeft(element, transformOrigin?.horizontal),
      vertical: getOffsetTop(element, transformOrigin?.vertical),
    };

    const elemRect = {
      width: el.offsetWidth,
      height: el.offsetHeight,
    };

    top = top - elemTransformOrigin.vertical;
    left = left - elemTransformOrigin.horizontal;
    const bottom = top + elemRect.height;
    const right = left + elemRect.width;

    const heightThreshold = window.innerHeight - marginThreshold;
    const widthThreshold = window.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

    if (top < marginThreshold) {
      const diff = top - marginThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    } else if (bottom > heightThreshold) {
      const diff = bottom - heightThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    }

    if (left < marginThreshold) {
      const diff2 = left - marginThreshold;

      left -= diff2;
      elemTransformOrigin.horizontal += diff2;
    } else if (right > widthThreshold) {
      const diff3 = right - widthThreshold;

      left -= diff3;
      elemTransformOrigin.horizontal += diff3;
    }

    return {
      top: `${Math.round(top)}px`,
      left: `${Math.round(left)}px`,
      transformOrigin: getTransformOriginValue(elemTransformOrigin),
    };
  }
};

export const getScrollbarSize = (): number => {
  const scrollDiv = document.createElement('div');
  scrollDiv.style.width = '99px';
  scrollDiv.style.height = '99px';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  const scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarSize;
};
